// extracted by mini-css-extract-plugin
export var currencyInput = "_ld-1";
export var currencySymbol = "_ld-0";